import React, { Component } from "react";
import Footer from "../template/Footer";
import HeaderNavbar from "../template/HeaderNavbar";
import DisclaimerMessage from "vidalink-disclaimer-message";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div>
        <HeaderNavbar />
        <DisclaimerMessage msg={this.state.message} />
        <div className="container">
          <section className="section section-recent">
            <div className="row">
              <div className="col s12 l12 m12">
                <div className="card">
                  <div className="card-content">
                    <div className="row">
                      <div
                        className="col s12 l12"
                        style={{ marginTop: "100px", marginBottom: "120px" }}
                      >
                        <span className="card-title card-title--gestao">
                          <center>Sessão expirada</center>
                        </span>
                        <p align="center">
                          Faça novamente o login no Portal Empresas.<br></br>
                          <a href="http://www.vidalink.com.br/portalempresas">
                            clique aqui
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Home;
